var _path, _circle, _path2, _circle2, _path3, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path4, _path5, _path6, _path7, _circle4, _path8, _circle5, _path9, _circle6, _path10, _circle7, _polygon, _path11, _polygon2, _path12, _path13, _path14, _path15, _circle8, _path16, _path17, _path18, _path19, _path20, _path21, _circle9, _path22, _path23, _circle10, _path24, _circle11, _path25, _circle12, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreelancer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 655,
    height: 413.67951,
    viewBox: "0 0 655 413.67951",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M689.063,372.583a122.04116,122.04116,0,0,1,10.10051-38.51722q2.27961-5.09249,5.01812-9.96076a.7438.7438,0,0,0-1.28354-.75026,123.7286,123.7286,0,0,0-13.7678,37.98231q-1.03367,5.58355-1.55378,11.24593c-.08811.95214,1.39893.94613,1.48649,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 435.2819,
    cy: 73.9144,
    r: 9.4144,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M690.026,372.83307a79.17357,79.17357,0,0,1,6.55267-24.98791q1.47888-3.30374,3.25549-6.462a.48254.48254,0,0,0-.83269-.48673,80.26825,80.26825,0,0,0-8.93182,24.6409q-.67059,3.6223-1.008,7.29575c-.05716.6177.90755.6138.96436,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.66984,
    cy: 93.66195,
    r: 6.10756,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M688.80883,372.25653a79.17368,79.17368,0,0,1-10.2024-23.73277q-.86592-3.51453-1.40764-7.09749a.48253.48253,0,0,0-.95592.12838,80.26823,80.26823,0,0,0,8.11306,24.92247q1.69918,3.26856,3.69253,6.37254c.33485.5222,1.09311-.07422.76037-.59313Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.73518,
    cy: 93.23322,
    r: 6.10756,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M670.05906,377.66024v-12a4.50508,4.50508,0,0,1,4.5-4.5h28a4.50508,4.50508,0,0,1,4.5,4.5v12a4.50508,4.50508,0,0,1-4.5,4.5h-28A4.50508,4.50508,0,0,1,670.05906,377.66024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,701.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 413.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 413.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M731.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,731.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 443.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 443.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M761.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,761.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 473.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 473.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M777.55906,382.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,777.55906,382.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 489.05906,
    y: 90.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 489.05906,
    y: 121.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M807.55906,382.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,807.55906,382.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 519.05906,
    y: 90.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 519.05906,
    y: 121.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M837.55906,382.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,837.55906,382.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 549.05906,
    y: 90.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 549.05906,
    y: 121.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M698.55906,463.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,698.55906,463.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 410.05906,
    y: 171.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 410.05906,
    y: 202.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M728.55906,463.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,728.55906,463.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 440.05906,
    y: 171.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 440.05906,
    y: 202.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M758.55906,463.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,758.55906,463.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 470.05906,
    y: 171.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 470.05906,
    y: 202.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M791.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,791.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 503.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 503.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M821.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,821.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 533.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 533.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M851.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,851.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 563.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 563.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M881.55906,301.16024h-12a4.50507,4.50507,0,0,1-4.5-4.5v-49a4.50508,4.50508,0,0,1,4.5-4.5h12a4.50508,4.50508,0,0,1,4.5,4.5v49A4.50508,4.50508,0,0,1,881.55906,301.16024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 593.05906,
    y: 9.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 593.05906,
    y: 40.5,
    width: 20,
    height: 4,
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M926.5,302.66024h-285a1,1,0,0,1,0-2h285a1,1,0,0,1,0,2Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M926.5,383.66024h-285a1,1,0,0,1,0-2h285a1,1,0,0,1,0,2Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M926.5,464.66024h-285a1,1,0,0,1,0-2h285a1,1,0,0,1,0,2Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M854.063,453.583a122.04116,122.04116,0,0,1,10.10051-38.51722q2.27961-5.09249,5.01812-9.96076a.7438.7438,0,0,0-1.28354-.75026,123.7286,123.7286,0,0,0-13.7678,37.98231q-1.03367,5.58355-1.55378,11.24593c-.08811.95214,1.39893.94613,1.48649,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 600.2819,
    cy: 154.9144,
    r: 9.4144,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M855.026,453.83307a79.17357,79.17357,0,0,1,6.55267-24.98791q1.47888-3.30374,3.25549-6.462a.48254.48254,0,0,0-.83269-.48673,80.26825,80.26825,0,0,0-8.93182,24.6409q-.67059,3.6223-1.008,7.29575c-.05716.6177.90755.6138.96436,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 594.66984,
    cy: 174.66195,
    r: 6.10756,
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M853.80883,453.25653a79.17368,79.17368,0,0,1-10.2024-23.73277q-.86592-3.51453-1.40764-7.09749a.48253.48253,0,0,0-.95592.12838,80.26823,80.26823,0,0,0,8.11306,24.92247q1.69918,3.26856,3.69253,6.37254c.33485.5222,1.09311-.07422.76037-.59313Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.73518,
    cy: 174.23322,
    r: 6.10756,
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M835.05906,458.66024v-12a4.50508,4.50508,0,0,1,4.5-4.5h28a4.50508,4.50508,0,0,1,4.5,4.5v12a4.50508,4.50508,0,0,1-4.5,4.5h-28A4.50508,4.50508,0,0,1,835.05906,458.66024Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M654.5,606.66024h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.05906,
    cy: 205.5,
    r: 27,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "173.405 378.826 172.69 366.588 219.556 358.003 220.612 376.067 173.405 378.826",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M436.62166,598.16324h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H421.7348a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,436.62166,598.16324Z",
    transform: "translate(747.34041 -113.14222) rotate(86.65462)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "193.789 378.714 186.004 388.185 145.768 362.666 157.257 348.688 193.789 378.714",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M454.38952,629.78677h23.64386a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H439.50266a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,454.38952,629.78677Z",
    transform: "translate(-597.31958 343.86136) rotate(-50.58212)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M443.88663,577.83023l-5.31975,25.07884a4,4,0,0,0,3.84843,4.8295l52.29785.84351a4,4,0,0,0,4.00364-4.69462l-4.57453-25.92236a4,4,0,0,0-3.93914-3.30486H447.79957A4,4,0,0,0,443.88663,577.83023Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M452.55906,586.66024s-51-32-61-15c-5,8.5-2.5,16.75,1.25,22.875a34.63053,34.63053,0,0,0,14.4025,12.89112l41.3475,20.23388,15-16-10-9Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M478.55906,581.66024s66-19,53,17-62,22-62,22l-5-15,17-12Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.39764,
    cy: 211.66535,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M473.18454,585.629a131.99386,131.99386,0,0,1-30.25708-3.98633l-.29248-.08007-13.70556-63.04493a23.2247,23.2247,0,0,1,14.93286-26.94335,80.45969,80.45969,0,0,1,51.29956-1.02442h.00024a23.46956,23.46956,0,0,1,15.635,27.76465l-15.30835,63.19531-.21557.10254C488.91135,584.62606,480.956,585.629,473.18454,585.629Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M454.77438,590.52651a10.05573,10.05573,0,0,1,14.47536-5.31221l26.98651-23.42452,2.44163,18.40848-26.00117,19.4221a10.11027,10.11027,0,0,1-17.90233-9.09385Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M480.51218,595.63583a4.53353,4.53353,0,0,1-1.29639-.19043,4.45263,4.45263,0,0,1-2.9624-2.81641l-3.25732-9.22851a4.472,4.472,0,0,1,1.30224-4.90235l36.7688-22.07422L496.573,491.76278l.36865-.08887c.14991-.0371,15.00025-3.417,21.0857,12.81055,4.26147,11.36524,20.03149,36.07715,18.91894,52.77637a14.88461,14.88461,0,0,1-12.322,13.72754l-41.38818,23.71289A4.456,4.456,0,0,1,480.51218,595.63583Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M484.63609,588.33293a10.05575,10.05575,0,0,0-14.47536-5.31221l-26.9865-23.42452-2.44163,18.40848,26.00117,19.4221a10.11027,10.11027,0,0,0,17.90232-9.09385Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M461.60593,595.63583a4.456,4.456,0,0,1-2.72388-.93457l-44.38818-21.71289a14.88461,14.88461,0,0,1-12.322-13.72754c-1.11255-16.69922,17.65747-43.41113,21.91894-54.77637,6.085-16.22754,20.93555-12.84863,21.0857-12.81055l.36865.08887L428.051,558.42391l39.7688,20.07422a4.472,4.472,0,0,1,1.30224,4.90235l-3.25732,9.22851a4.45263,4.45263,0,0,1-2.9624,2.81641A4.5348,4.5348,0,0,1,461.60593,595.63583Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M514.55908,605.66016h-89a7.00818,7.00818,0,0,1-7-7v-49a7.00818,7.00818,0,0,1,7-7h89a7.00817,7.00817,0,0,1,7,7v49A7.00818,7.00818,0,0,1,514.55908,605.66016Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#6c63ff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.55906,
    cy: 331,
    r: 6,
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M447.09061,453.82593c-1.45566-3.6923.93266-8.09242,4.47568-9.881s7.81846-1.44843,11.60824-.26964c3.18484.99063,6.16976,2.52588,9.27688,3.73845a20.76152,20.76152,0,0,0,9.75287,1.73691c3.31428-.37431,6.61291-2.23278,7.96907-5.28,1.40574-3.15859.44963-7.01316-1.71516-9.7088a18.79922,18.79922,0,0,0-8.61171-5.5348c-7.3075-2.57443-15.74829-2.64969-22.53234,1.0925s-11.39446,11.7102-9.99219,19.33",
    transform: "translate(-272.5 -243.16024)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M305.16247,594.9787A122.0417,122.0417,0,0,1,315.263,556.46148q2.27961-5.09249,5.01813-9.96076a.7438.7438,0,0,0-1.28354-.75026,123.72825,123.72825,0,0,0-13.7678,37.98231q-1.03366,5.58356-1.55378,11.24593c-.08811.95214,1.39893.94613,1.48648,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.38142,
    cy: 296.31007,
    r: 9.4144,
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.1255,595.22874a79.1741,79.1741,0,0,1,6.55267-24.98791q1.47889-3.30373,3.25549-6.462a.48254.48254,0,0,0-.83269-.48673,80.26852,80.26852,0,0,0-8.93181,24.64089q-.67059,3.62232-1.008,7.29576c-.05716.6177.90755.6138.96435,0Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.76935,
    cy: 316.05762,
    r: 6.10756,
    fill: "#6c63ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M304.90835,594.6522a79.174,79.174,0,0,1-10.20241-23.73277q-.86592-3.51453-1.40763-7.09749a.48253.48253,0,0,0-.95592.12838,80.26809,80.26809,0,0,0,8.11306,24.92246q1.69919,3.26857,3.69252,6.37255c.33485.5222,1.09311-.07422.76038-.59313Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8347,
    cy: 315.62888,
    r: 6.10756,
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.15857,600.05591v-12a4.50508,4.50508,0,0,1,4.5-4.5h28a4.50508,4.50508,0,0,1,4.5,4.5v12a4.50508,4.50508,0,0,1-4.5,4.5h-28A4.50508,4.50508,0,0,1,286.15857,600.05591Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#f2f2f2",
    style: {
      isolation: "isolate"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M586.90885,614.06085c0,6.57707-5.33178,9.56657-11.90885,9.56657s-11.90885-2.9895-11.90885-9.56657S565.73756,599.80972,575,602.45614C584.26244,598.48652,586.90885,607.48377,586.90885,614.06085Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#ff6584"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M574.41992,605.53711a1.90366,1.90366,0,0,1-1.89111-1.65918c-.39429-3.28125-2.56763-9.708-3.48364-12.31836l-.00025-.001a1.703,1.703,0,0,1,.22022-1.5664,1.78652,1.78652,0,0,1,2.66333-.19239,1.70477,1.70477,0,0,1,.46826,1.27637c-.17944,3.35059,2.26294,8.76465,3.73486,11.69434a1.90795,1.90795,0,0,1-1.50976,2.75586A1.76339,1.76339,0,0,1,574.41992,605.53711Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M583.232,598.14572c4.13393-3.38342.89056-10.30763-4.28341-8.9784a4.17809,4.17809,0,0,0-1.8637.99416c-3.17381,2.99811-3.66567,10.66906-3.66567,10.66906S579.02377,601.58992,583.232,598.14572Z",
    transform: "translate(-272.5 -243.16024)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancer);
export default __webpack_public_path__ + "static/media/freelancer.52398fba0938744a7f8bd71b8e774617.svg";
export { ForwardRef as ReactComponent };